<template>
    <component :is="currentComponent" />
</template>

<script>
import XiHome from '@/components/showcase/home/XiHome'
import KocomHome from '@/components/showcase/home/KocomHome'

export default {
    name: 'home',
    components: {
        XiHome,
        KocomHome
    },
    computed: {
        currentComponent: function() {
            const componentMap = {
                xi: 'XiHome',
                kocom: 'KocomHome'
            }
            return componentMap[this.$route.params.showcase] || 'XiHome'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/showcase/Home.vue